import { Link } from "react-router-dom";

export const Logo = ({ to = "/" }) => (
    <Link
        to={to}
        aria-label="Smart Solutions home"
        data-testid="brand-logo"
        className="inline-flex items-center group"
    >
        <div className="relative">
            {/* Optional glow behind the logo */}
            <div
                className="absolute inset-0 bg-gradient-to-r from-[#2A7BFF]/30 to-[#FF2E3C]/30 blur-xl opacity-60 group-hover:opacity-100 transition-opacity rounded-xl"
                aria-hidden="true"
            />

            <img
                src="/logo.png"
                alt="Smart Solutions"
                className="w-[280px] h-[60px] object-contain transition-transform duration-500 group-hover:scale-105"
                draggable="false"
            />
        </div>
    </Link>
);

export default Logo;